import { buildModelManager } from "../builder.js";
const DefaultAiTrainingDataSelection = {
  __typename: true,
  id: true,
  actualCost: true,
  aiResponse: { markdown: true, truncatedHTML: true },
  assistantUsedId: true,
  batchId: true,
  conversationId: true,
  createdAt: true,
  deployedToAssistants: true,
  estimatedCost: true,
  fineTunedModel: true,
  hyperparameters: true,
  isActive: true,
  jobStatus: true,
  modelVersion: true,
  openaiFileId: true,
  openaiJobId: true,
  originalModel: true,
  qualityScore: true,
  requiresReview: true,
  reviewedAt: true,
  reviewedById: true,
  reviewerFeedback: { markdown: true, truncatedHTML: true },
  sessionData: true,
  tags: true,
  timestamp: true,
  trainingCategory: true,
  trainingCompletedAt: true,
  trainingMetrics: true,
  trainingStartedAt: true,
  trainingTokens: true,
  updatedAt: true,
  uploadedAt: true,
  userId: true,
  userInput: { markdown: true, truncatedHTML: true },
  userReportReason: true,
  userReported: true,
  validationMetrics: true,
  validationTokens: true
};
const modelApiIdentifier = "aiTrainingData";
const pluralModelApiIdentifier = "aiTrainingDatas";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiTrainingDataSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiTrainingDataSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiTrainingDataSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiTrainingDataSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiTrainingDataSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiTrainingDataSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiTrainingDataSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAiTrainingData",
    operationReturnType: "CreateAiTrainingData",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      aiTrainingData: { required: false, type: "CreateAiTrainingDataInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAiTrainingDataSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAiTrainingData",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAiTrainingDataInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAiTrainingDataSelection
  },
  {
    type: "action",
    operationName: "updateAiTrainingData",
    operationReturnType: "UpdateAiTrainingData",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      aiTrainingData: { required: false, type: "UpdateAiTrainingDataInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAiTrainingDataSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAiTrainingData",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAiTrainingDataInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAiTrainingDataSelection
  },
  {
    type: "action",
    operationName: "deleteAiTrainingData",
    operationReturnType: "DeleteAiTrainingData",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAiTrainingData",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAiTrainingData",
    operationReturnType: "UpsertAiTrainingData",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      aiTrainingData: { required: false, type: "UpsertAiTrainingDataInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAiTrainingDataResult": { hasReturnType: false },
      "... on UpdateAiTrainingDataResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAiTrainingDataSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAiTrainingData",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAiTrainingDataInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAiTrainingDataSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "aiTrainingDataGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AiTrainingDataManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAiTrainingDataSelection,
  operations
);
export {
  AiTrainingDataManager,
  DefaultAiTrainingDataSelection
};
//# sourceMappingURL=AiTrainingData.js.map
